module.exports = __webpack_public_path__ + "static/media/blinds-open.a0ba3639.svg";